"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const CheckCircleRounded_1 = require("@mui/icons-material/CheckCircleRounded");
const PersonOutlineOutlined_1 = require("@mui/icons-material/PersonOutlineOutlined");
const material_1 = require("@mui/material");
const merge_1 = require("merge");
const selection_indicatior_styles_1 = require("./selection-indicatior.styles");
const Checkbox_1 = require("../Checkbox");
const AddItem_1 = require("../AddItem");
const SelectionIndicator = (_a) => {
    var { value, onValueChange, min, max, disabled, paid, fullWidth, tick, checkboxSelector, splitByItemV2Selector, addId, removeId, splitByShareV2UI, qaId } = _a, rest = __rest(_a, ["value", "onValueChange", "min", "max", "disabled", "paid", "fullWidth", "tick", "checkboxSelector", "splitByItemV2Selector", "addId", "removeId", "splitByShareV2UI", "qaId"]);
    const [count, setCount] = (0, react_1.useState)(0);
    const styles = (0, selection_indicatior_styles_1.default)({
        disabled,
        min,
        max,
        count,
        fullWidth,
        splitByShareV2UI,
    });
    (0, react_1.useEffect)(() => {
        if (value === undefined) {
            return;
        }
        if (min && min > value) {
            setCount(min);
            onValueChange(min, 'remove');
            return;
        }
        if (max && max > 0 && max < value) {
            setCount(max);
            onValueChange(max, 'add');
            return;
        }
        if (value !== count) {
            setCount(value);
        }
    }, [value, min, max]);
    const addCount = (e) => {
        const newValue = count + 1;
        if (max && newValue > max) {
            return;
        }
        setCount(newValue);
        onValueChange(newValue, 'add', e);
    };
    const removeCount = (e) => {
        const newValue = count - 1;
        if (newValue === -1 || (min && min > newValue)) {
            return;
        }
        setCount(newValue);
        onValueChange(newValue, 'remove', e);
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Box, Object.assign({}, rest, { sx: styles.container, children: paid ? (splitByItemV2Selector ? ((0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(PersonOutlineOutlined_1.default, { sx: styles.paidUserIcon }) })) : ((0, jsx_runtime_1.jsx)(CheckCircleRounded_1.default, { color: "primary", sx: styles.paidIcon }))) : checkboxSelector ? ((0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: value === 1, onClick: (e) => {
                if (value === 1) {
                    removeCount(e);
                }
                else {
                    addCount(e);
                }
            } })) : splitByItemV2Selector ? ((0, jsx_runtime_1.jsx)(AddItem_1.default, { disabled: disabled, state: value === 1, onClick: (e) => {
                if (value === 1) {
                    removeCount(e);
                }
                else {
                    addCount(e);
                }
            } })) : ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: styles.indicator, "data-qa-id": qaId, children: [(0, jsx_runtime_1.jsx)(material_1.IconButton, { sx: (0, merge_1.merge)(true, styles.button, styles.minButton), onClick: removeCount, disabled: disabled, id: removeId, children: (0, jsx_runtime_1.jsx)(icons_material_1.RemoveRounded, { sx: (0, merge_1.merge)(true, styles.icon, styles.minusIcon) }) }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: styles.text, children: count }), tick && count === max ? ((0, jsx_runtime_1.jsx)(material_1.IconButton, { sx: styles.button, disabled: disabled, children: (0, jsx_runtime_1.jsx)(icons_material_1.CheckRounded, { sx: (0, merge_1.merge)(true, styles.icon, styles.checkIcon) }) })) : ((0, jsx_runtime_1.jsx)(material_1.IconButton, { sx: (0, merge_1.merge)(true, styles.button, styles.maxButton), onClick: addCount, disabled: disabled, id: addId, children: (0, jsx_runtime_1.jsx)(icons_material_1.AddRounded, { sx: (0, merge_1.merge)(true, styles.icon, styles.plusIcon) }) }))] })) })));
};
exports.default = SelectionIndicator;
